<template>
  <div class="about">
    <div class="modal active">
      <a class="modal-overlay" aria-label="Close"></a>
      <div class="modal-container"> 
        <div class="modal-header">
          <a class="btn btn-clear float-right" aria-label="Close" @click="close()"></a>
        </div>
        <div class="modal-title h3 text-primary">FlightBook</div>
        <div class="modal-body">
          <div class="content">
            <div>
              <a href="https://www.glidernet.org/" target="_blank"><img class="img-fit-contain" src="@/assets/ogn.gif"></a>
            </div>
            Code & Api:
            <div>
              <a href="https://gitlab.com/lemoidului/ogn-flightbook" target="_blank">gitlab.com/lemoidului/ogn-flightbook</a>
            </div>
            <div>
              GNU Affero General Public LICENSE
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "About",
methods: {
  close() {
      this.$emit('close');
  },
}
}
</script>

